import React, { Suspense } from 'react';
import { useLazyLoadQuery } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';
import { ErrorBoundary } from 'core';

import { CardPatient, CardPatientProps } from 'deprecated/fragments';

import { WrapperCardPatientQuery } from './__generated__/WrapperCardPatientQuery.graphql';

export interface WrapperCardPatientProps extends Omit<CardPatientProps, 'classes' | 'fragmentRef'> {
  patient: string;
}

const WrapperCardPatient: React.FC<WrapperCardPatientProps> = ({ patient, ...rest }) => {
  const { patientById } = useLazyLoadQuery<WrapperCardPatientQuery>(
    graphql`
      query WrapperCardPatientQuery($id: MongoID!) {
        patientById(_id: $id) {
          ...CardPatient_Patient
        }
      }
    `,
    { id: patient },
  );

  if (!patientById) {
    return null;
  }
  return <CardPatient fragmentRef={patientById} {...rest} />;
};

export default (props: WrapperCardPatientProps) => (
  <ErrorBoundary>
    <Suspense fallback={null}>
      <WrapperCardPatient {...props} />
    </Suspense>
  </ErrorBoundary>
);
